import React, { useEffect, useState } from "react";
import "./TeamStaff.css";

export default function TeamStaff({ staff = [], status = "unavailable", context = "season", season, stale = false, onRetry }) {
  const match = context === "match";
  return <details className="team-staff team-squad__staff" aria-label="Ledare">
    <summary><span>Ledare{(staff.length > 0 || status === "empty") && ` (${staff.length})`}</span>{season && <small>Säsong {season}</small>}</summary>
    <div className="team-staff__content">
    {staff.length ? <ul>{staff.map(person => <li key={person.id} className="team-staff__row team-squad__staff-row">
      <span className="team-staff__name">{person.name}</span>
      <span className="team-staff__role">{person.roles?.join(" · ") || "Ledare"}</span>
    </li>)}</ul> : status === "loading" ? <p role="status">Hämtar ledare…</p>
      : status === "error" ? <div role="alert"><p>Ledarna kunde inte hämtas just nu.</p><button type="button" onClick={onRetry}>Försök igen</button></div>
        : <p>{status === "empty" ? `Inga ledare är publicerade för ${match ? "matchen" : "laget"} ännu.` : `Ledaruppgifter saknas för den här ${match ? "matchen" : "säsongen"}.`}</p>}
    {stale && <p>Senast hämtade ledaruppgifter visas. Källan kan inte uppdateras just nu.</p>}
    </div>
  </details>;
}

function SeasonStaff({ simulation, teamId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!simulation || !teamId) return undefined;
    const controller = new AbortController();
    setError(false);
    setData(null);
    const query = new URLSearchParams({ sport: "football", simulation, team_id: teamId });
    fetch(`/sportsim/api/team-squad?${query}`, { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(value => { if (!controller.signal.aborted) setData(value); })
      .catch(failure => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [simulation, teamId, attempt]);
  return <TeamStaff staff={data?.staff} season={data?.season} stale={data?.stale}
    status={error ? "error" : data ? data.staff_status : simulation && teamId ? "loading" : "unavailable"}
    onRetry={() => setAttempt(value => value + 1)} />;
}

export function SeasonTeamStaff(props) {
  return <SeasonStaff key={`${props.simulation}:${props.teamId}`} {...props} />;
}
